import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import type { LaborCostChartService } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartService.ts";
import ToggleButton from "@/shared/components/generic/button/toggle-button/ToggleButton.tsx";
import ToggleButtonGroup from "@/shared/components/generic/button/toggle-button/ToggleButtonGroup.tsx";
import "./SwitchLaborCostService.scss";

interface Props {
  selectedServiceIndex: number | undefined;
  onChange: (value: number | undefined) => void;
  services: LaborCostChartService[];
}

export default function SwitchLaborCostService({
  selectedServiceIndex,
  onChange,
  services,
}: Props): ReactElement {
  const { t } = useTranslation("common");

  const handleChange = (index: number | undefined) => (): void => {
    if (index !== selectedServiceIndex) {
      onChange(index);
    }
  };

  return (
    <div className="switch-labor-cost-service">
      <ToggleButtonGroup direction="vertical">
        <ToggleButton
          text={t("time.day")}
          selected={selectedServiceIndex === undefined}
          onClick={handleChange(undefined)}
          outlined
        />
        {services.map((service) => (
          <ToggleButton
            key={service.index}
            text={service.label}
            selected={selectedServiceIndex === service.index}
            onClick={handleChange(service.index)}
            outlined
          />
        ))}
      </ToggleButtonGroup>
    </div>
  );
}
